var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-timeline',{style:(`height:${_vm.height};overflow:auto`),attrs:{"reverse":_vm.reverse}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }